import { addressKey, rememberedAddresses } from './nearby-places';
import { PlacePick, pickCoordinates, pickDestination } from './place-picks';

/**
 * Moves a route's Start or End to what was picked in the place search: one of
 * our places or a Google Maps one (pinned there — the Google one as a
 * highlight of the route's day), or a plain address. Shared by the route
 * card's endpoint rows (RouteEndpoints.vue) and the new plan's get-started
 * fields (PlanTrailGetStarted.vue), so the two can't drift apart.
 */
export async function moveEndpointToPick(
  dispatch: (action: string, payload?: any) => Promise<any>,
  input: { routeKey: string; which: 'start' | 'end'; dayNumber: number; pick: PlacePick }
): Promise<boolean> {
  const { routeKey, which, dayNumber, pick } = input;
  const destination = pick.kind === 'google'
    ? await dispatch('planTrail/addHighlightForPick', { pick, dayNumber })
    : pickDestination(pick);
  const coordinates = pickCoordinates(pick);
  // The label is already known — no need to look it up again once the end lands.
  if (pick.kind === 'address') rememberedAddresses.set(addressKey(coordinates), pick.name);
  return dispatch('planTrail/setRouteEndpoint', { routeKey, which, coordinates, destination });
}

/**
 * Carries a route on from its end to what was picked: the old end stays as a
 * control point and the route is drawn on to the pick (a place is recorded
 * as the day's stop, as above). See extendRouteEndpoint.
 */
export async function extendRouteToPick(
  dispatch: (action: string, payload?: any) => Promise<any>,
  input: { routeKey: string; dayNumber: number; pick: PlacePick }
): Promise<boolean> {
  const { routeKey, dayNumber, pick } = input;
  const destination = pick.kind === 'google'
    ? await dispatch('planTrail/addHighlightForPick', { pick, dayNumber })
    : pickDestination(pick);
  const coordinates = pickCoordinates(pick);
  if (pick.kind === 'address') rememberedAddresses.set(addressKey(coordinates), pick.name);
  return dispatch('planTrail/extendRouteEndpoint', { routeKey, coordinates, destination });
}
